import { useMenuState } from '@szhsin/react-menu';
import cn from 'classnames';

import { INCOME } from 'constants/user';
import i18n from 'i18n/config';
import Box from 'UIKit/Box';
import FilterDropDown from 'UIKit/FilterDropDown';

import { IncomeDropdownProps } from './ManadatoryDeclarationModal.types';
import styles from './mandatoryDeclarationModal.module.scss';
import SelectedLabel from './SelectedLabel';

const userIncomeLabel = i18n.t('account:whatIsYourAnnualIncome');

const IncomeDropDown = ({
  selectedValue,
  errorMessage,
  onIncomeOptionClicked,
}: IncomeDropdownProps) => {
  const [menuState, toggleMenu] = useMenuState();

  const options = INCOME.map(userIncome => ({
    label: <SelectedLabel optionId={userIncome} selectedId={selectedValue} />,
    id: userIncome,
    onClick: () => onIncomeOptionClicked(userIncome),
    checked: selectedValue === userIncome,
    dataTestId: userIncome,
  }));

  return (
    <Box className={styles.incomeDropDownContainer}>
      <Box data-testid="userIncomeLabel" className={styles.dropDownLabel}>
        {userIncomeLabel}
      </Box>

      <FilterDropDown
        menuState={menuState}
        toggleMenu={toggleMenu}
        options={options}
        label={selectedValue || ''}
        testId="income-dropdown"
        closeOnSelect
        className={styles.incomeDropDownContainer}
        styleOverrideClasses={{
          button: cn(styles.button, {
            [styles.buttonErrorHighlighted]: errorMessage,
          }),
          labelSection: cn({
            [styles.labelSectionWhenResidence]: selectedValue,
            [styles.labelSectionWhenNoResidence]: !selectedValue,
          }),
          label: styles.label,
          dropDown: styles.dropDown,
          optionLabel: styles.optionLabelClass,
        }}
      />
    </Box>
  );
};

export default IncomeDropDown;
